module.exports = __webpack_public_path__ + "static/media/archero2_logo_en@2x.5d581f35.png";